import { db } from '../../common/config/Firebase';

/**
 * Deletes a holiday from the collection
 * @param {string} holidayId - Holiday document ID
 * @returns {Promise<void>}
 */
export const deleteHolidayUseCase = async (holidayId) => {
    try {
        await db.collection('holidays').doc(holidayId).delete();
        console.log('Holiday deleted:', holidayId);
    } catch (error) {
        console.error('Error deleting holiday:', error);
        throw error;
    }
};
